import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import { i18n } from '../AdvancedSearch-i18n.ts';

import { ResultsInfoContainer, ResultsCountContainer } from './styled.tsx';

interface ResultCountDisplayProps {
	numberOfResults: number;
	totalCount?: number | null;
}

export const ResultCountDisplay = ({ numberOfResults, totalCount }: ResultCountDisplayProps) => {
	return (
		<ResultsInfoContainer>
			<ResultsCountContainer data-testid="advanced-search-result-count" tabIndex={-1}>
				<FormattedMessage {...i18n.numberOfResults} values={{ numberOfResults, totalCount }} />
			</ResultsCountContainer>
		</ResultsInfoContainer>
	);
};
